<!--
@component
RootPage

Route page component.
-->

<script lang="ts">
  import Page from '$lib/components/HomePage/index.svelte';
  import SEO from '$lib/components/common/SEO/SEO.svelte';

  import { appState } from '$lib/stores/index.svelte';
  import { resolve } from '$app/paths';

  import getContestedMatches from '$utils/getContestedMatches';
  import parseSeo from '$utils/parseSeo';

  let { data } = $props();

  /**
   * Content comes from a live endpoint, if one is turned on, in
   * preview or published page. NOTE: If you have more than one
   * story in this project, you'll likely need to adjust this.
   */
  const content = $derived(data.content);

  /**
   * Retrieves the contestant matches from the data object.
   * If the data object is null, returns an empty array.
   * Otherwise, filters the matches based on the following conditions:
   * - The matchInfo must have a contestant property.
   * - The contestant property must have a length of 2.
   * @returns {Array} The filtered contestant matches.
   */
  const contestedMatches = $derived(getContestedMatches(appState.optaData));

  // The home page reads SEO fields from the top level of `content` rather
  // than a nested key (unlike other pages which use e.g. `content['groups-seo']`).
  const seo = $derived(parseSeo(content, null));
</script>

<SEO {seo} />

<Page data={appState.optaData} {content} />

<!-- Hidden link block: lets crawlers discover match/team pages without JS. -->
<div class="hidden">
  <!-- Renders links to matches -->
  {#if contestedMatches.length}
    <div>
      {#each contestedMatches as match}
        {#if match.path && match.path !== '.'}
          <!-- eslint-disable-next-line @typescript-eslint/no-explicit-any -->
          <a href={resolve(`/${match.path}` as any)}>{match.label}</a>
        {/if}
      {/each}
    </div>
  {/if}

  <!-- Renders links to team pages -->
  {#if appState.teams.length}
    <div>
      {#each appState.teams as team}
        {#if team.path}
          <!-- eslint-disable-next-line @typescript-eslint/no-explicit-any -->
          <a href={resolve(`/${team.path}` as any)}>{team.name}</a>
          <!-- Sharecard -->
          <!-- <a href={resolve(`/${team.path}share/` as any)}>{`${team.name} Sharecard`}</a> -->
        {/if}
      {/each}
    </div>
  {/if}
</div>
